import { FETCH_MULTI_LOAN } from '../types'
export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_MULTI_LOAN:
      return action.payload
    default:
      return state;
  }
}